import { Guid, IBaseModel } from '@/interfaces/base'
import emptyId from '@/statics/empty-id'

export class SalaryVariable implements IBaseModel {
	id: Guid = emptyId
	title: string | null = null
	value: number = 0
}